import script from "./MetadataView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetadataView.vue?vue&type=script&setup=true&lang=js"

import "./MetadataView.vue?vue&type=style&index=0&id=56552216&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56552216"]])

export default __exports__